export default "__VITE_ASSET__5cae5ae1__"